module.exports = __webpack_public_path__ + "img/sort_asc.742c3b3e.svg";